import Image from '@app/components/Image'
import { Attachment, IAttachment } from '@app/models/Attachment'
import { ImageSize } from '@app/models/enums'
import { bindFunctions } from '@app/utils/class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames'
import * as React from 'react'
import './ImageLinker.scss'

interface IImageLinkerProps {
  className?: string
  image: IAttachment
  isLinked: boolean
  isMain: boolean
  onLink: (image: Attachment) => void
  onSetAsMain: (imageId: string) => void
  onUnlink: (imageId: string) => void
  parentType: string
  style?: React.CSSProperties
}

export default class ImageLinker extends React.PureComponent<
  IImageLinkerProps
> {
  constructor(props: IImageLinkerProps) {
    super(props)
    bindFunctions(this)
  }

  public render() {
    return (
      <div
        className={classNames('image-linker-container', this.props.className)}
        style={this.props.style}
      >
        <Image
          className='w-100'
          image={this.props.image}
          size={ImageSize.h200w250}
        />
        <div className='image-linker-action-bar'>
          <div className='text-primary'>
            {this.props.isMain && <span className='ml-2'>Main image</span>}
          </div>
          {!this.props.isLinked && (
            <div>
              <a
                className='text-primary d-inline-block px-2 py-1'
                onClick={this._link}
                role='button'
                title={`Add image to ${this.props.parentType}`}
              >
                <FontAwesomeIcon fixedWidth icon={['far', 'plus']} size='lg' />
              </a>
            </div>
          )}
          {this.props.isLinked && (
            <div>
              {!this.props.isMain && (
                <a
                  className='text-primary d-inline-block px-2 py-1'
                  role='button'
                  onClick={this._setAsMain}
                  title='Set as main image'
                >
                  <FontAwesomeIcon
                    fixedWidth
                    icon={['far', 'image']}
                    size='lg'
                  />
                </a>
              )}
              <a
                className='text-danger d-inline-block px-2 py-1'
                onClick={this._unlink}
                role='button'
                title={`Remove image to ${this.props.parentType}`}
              >
                <FontAwesomeIcon fixedWidth icon={['far', 'times']} size='lg' />
              </a>
            </div>
          )}
        </div>
      </div>
    )
  }

  private _link() {
    this.props.onLink(this.props.image as Attachment)
  }

  private _setAsMain() {
    this.props.onSetAsMain(this.props.image.id)
  }

  private _unlink() {
    this.props.onUnlink(this.props.image.id)
  }
}
